<template>
  <div class="flex items-center justify-center gap-3">
    <NuxtLink v-for="league in data.leagues" :key="league.id" :to="{ name: 'leagues-league', params: { league: league.slug }}">
      <div class="flex items-center gap-3">
        <LeagueLogo class="w-10 md:w-14 aspect-square rounded-md overflow-hidden" :name="league.name" :slug="league.slug" />
      </div>
    </NuxtLink>
  </div>
</template>

<script setup>
const { data } = useFetch('/api/v1/leagues', { 
  key: 'leagues',
  baseURL: useEnv('apiBase'),
})
</script>